export const globalStyles = {
  col: {
    red: "#cd2e2e",
    grey: "#f6f3f3",
    purple: "#004243",
  },
}
